module.exports = __webpack_public_path__ + "img/walletconnect-logo.37f2bc6e.svg";